import DiagnosticTranslations from '../dto/translations/diagnosticTranslations';

const diagnosticErrorMessages: Record<string, string> = {
  CONFIG_TENANT_NOT_RESOLVED: 'HMRC integration configuration is incomplete.',
  ERPX_API_UNAUTHORIZED: 'ERPx API access failed. Check ERPx API access.',
  ERPX_API_FORBIDDEN: 'ERPx API access failed. Check ERPx API access.',
  ERPX_API_BAD_REQUEST: 'ERPx API rejected the diagnostic request. Check the ERPx API setup.',
  ERPX_API_UNREACHABLE: 'ERPx API access failed. Check ERPx API access.',
  MESSAGEHUB_AUTHORIZATION_FAILED: 'Messaging system problem. The request could not be sent.',
  MESSAGEHUB_ACCESS_PROVIDER_FAILED: 'Messaging system problem. The request could not be sent.',
  MESSAGEHUB_PUBLISH_FAILED: 'Messaging system problem. The request could not be sent.',
  RESPONSEHANDLER_EVENT_NOT_RECEIVED: 'Application response handler did not confirm the diagnostic result.',
  DIAGNOSTIC_UNEXPECTED: 'Diagnostic completed with errors.'
};

export function getDiagnosticErrorMessage(errorCode?: string | null, message?: string | null): string {
  if (message) {
    return message;
  }

  if (errorCode && diagnosticErrorMessages[errorCode]) {
    return diagnosticErrorMessages[errorCode];
  }

  return diagnosticErrorMessages.DIAGNOSTIC_UNEXPECTED;
}

export default function mapToDiagnosticTranslations(): DiagnosticTranslations {
  return {
    RunButton: 'Run diagnostics',
    RunningStatus: 'Running diagnostics...',
    LoadingStatus: 'Loading last diagnostic...',
    HealthyStatus: 'System healthy',
    FailedStatus: 'Diagnostics failed',
    ErrorStatus: 'Unable to run diagnostics',
    NotRunYetStatus: 'Diagnostic not run yet',
    DiagnosticUnexpected: diagnosticErrorMessages.DIAGNOSTIC_UNEXPECTED,
    PollTimeout: 'Diagnostic did not complete in the expected time.',
    RequestFailed: 'Diagnostics request failed',
    LoadFailed: 'Failed to load last diagnostic'
  };
}
